module.exports = __webpack_public_path__ + "img/acount_des_3.d623871c.jpg";